import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { deleteListById } from '../services/delete-list-by-id';

export function useListDeleteById(
  options?: Omit<
    UseMutationOptions<void, Error, string, unknown>,
    'mutationKey' | 'mutationFn'
  >,
) {
  return useMutation({
    mutationKey: ['lists/delete-by-ud'],
    mutationFn: deleteListById,
    ...options,
  });
}
